import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { routes } from './account.routes';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './signUp/signUp.component';
import { ResetPasswordComponent } from './resetPassword/resetPassword.component';
import { ConfirmResetPasswordComponent } from './confirmResetPassword/confirmResetPassword.component';
import { ActivateAccountComponent } from './activateAccount/activateAccount.component';
import { ContainerComponent } from './container/container.component';
import { AccountService } from './account.service';
import { FacebookLoginComponent } from '../+account/facebook-login/facebook-login.component';
import { GoogleLoginComponent } from './google-login/google-login.component';
import { EmailSignUpComponent } from './email-sign-up/email-sign-up.component';
import { MobileSignUpComponent } from './mobile-sign-up/mobile-sign-up.component';
import { AppleLoginComponent } from './apple-login/apple-login.component';
import { EmailLogInComponent } from './email-log-in/email-log-in.component';
import { MobileLogInComponent } from './mobile-log-in/mobile-log-in.component';
import { ResetMobilePasswordComponent } from './reset-mobile-password/reset-mobile-password.component';
import { AppleLoginService } from './_services/apple-login.service';

@NgModule({
  declarations: [
    ContainerComponent,
    LoginComponent,
    SignUpComponent,
    ResetPasswordComponent,
    ConfirmResetPasswordComponent,
    ActivateAccountComponent,
    FacebookLoginComponent,
    GoogleLoginComponent,
    EmailSignUpComponent,
    MobileSignUpComponent,
    AppleLoginComponent,
    EmailLogInComponent,
    MobileLogInComponent,
    ResetMobilePasswordComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    TranslateModule,
    SharedModule,
  ],
  providers: [AccountService, AppleLoginService],
  exports: [LoginComponent, SignUpComponent, FacebookLoginComponent],
})
export class AccountModule {
  public static routes = routes;
}

